import { Injectable, computed, Signal } from '@angular/core';
// import { StoreConfig, Store } from '@datorama/akita';
import { HeaderContext, UiState } from './ui.model';
import { Store, useDevtools } from 'signalstory';

export function createInitalUI(): UiState {
  return {
    online: true,
    headerHidden: false,
    hideHeaderShadow: false,
    menuHidden: false,
    menuOpen: false,
    showHeaderBg: false,
    backgroundBlur: false,
    preventScroll: false,
    navigationTrigger: null,
    annotationsActive: false,
    mapZoomIndicatorActive: false,
    mapDrawingScaleError: false,
    showSearch: true,
    shrinkHeader: false,
    clearHeader: false,
    spacedHeader: false,
    headerContext: null,
    allowThemeSwitching: true,
    allowLanguageSwitching: true,
    headerTransparent: false,
    activeSection: null,
    uiLanguage: null,
    hideMainFooter: false,
    fullscreen: false,
    nativeScrolling: true,
    headerCollapsed: false,
    contentWrapperScrollPosition: {
      position: 0,
      maxpos: 0,
      top: 0,
    },
  };
}

// @Injectable({ providedIn: 'root' })
// @StoreConfig({ name: 'ui' })
// export class UiStore extends Store<UiState> {
//   constructor() {
//     super(createInitalUI());
//   }
// }

@Injectable({ providedIn: 'root' })
export class UiStore extends Store<UiState> {
  constructor() {
    super({ initialState: createInitalUI(),
      plugins: [
        useDevtools()
      ],});
  }

  public get online$(): Signal<boolean> {
    return computed(() => this.state().online);
  }

  public get headerHidden$() {
    return computed(() => this.state().headerHidden);
  }

  public get headerShadowHidden$() {
    return computed(() => this.state().hideHeaderShadow);
  }

  public get menuHidden$() {
    return computed(() => this.state().menuHidden);
  }
  public get menuOpen$() {
    return computed(() => this.state().menuOpen);
  }
  public get backgroundBlur$() {
    return computed(() => this.state().backgroundBlur);
  }
  public get preventScroll$() {
    return computed(() => this.state().preventScroll);
  }
  public get contentWrapperScrollPosition$() {
    return computed(() => this.state().contentWrapperScrollPosition);
  }
  public get shrinkHeader$() {
    return computed(() => this.state().shrinkHeader);
  }
  public get showHeaderBg$() {
    return computed(() => this.state().showHeaderBg);
  }
  public get showSearch$() {
    return computed(() => this.state().showSearch);
  }
  public get headerContext$() {
    return computed(() => this.state().headerContext);
  }
  public get spacedHeader$() {
    return computed(() => this.state().spacedHeader);
  }
  public get allowThemeSwitching$() {
    return computed(() => this.state().allowThemeSwitching);
  }
  public get allowLanguageSwitching$() {
    return computed(() => this.state().allowLanguageSwitching);
  }
  public get headerTransparent$() {
    return computed(() => this.state().headerTransparent);
  }
  public get activeSection$() {
    return computed(() => this.state().activeSection);
  }
  public get uiLanguage$() {
    return computed(() => this.state().uiLanguage);
  }
  public get hideMainFooter$() {
    return computed(() => this.state().hideMainFooter);
  }
  public get mapDrawScaleError$() {
    return computed(() => this.state().mapDrawingScaleError);
  }
  public get fullscreen$() {
    return computed(() => this.state().fullscreen);
  }
  public get nativeScrolling$() {
    return computed(() => this.state().nativeScrolling);
  }
  public get clearHeader$() {
    return computed(() => this.state().clearHeader);
  }
  public get headerCollapsed$() {
    return computed(() => this.state().headerCollapsed);
  }
  public get notTop$() {
    return computed(() => this.state().contentWrapperScrollPosition.top > 0);
  }
  public get showHeader$() {
    return computed(() => this.state().contentWrapperScrollPosition.top > 0);
  }

  public get navigationTrigger() {
    return computed(() => this.state().navigationTrigger);
  }

  public get annotationsActive$(){
    return computed(() => this.state().annotationsActive);
  }

  public get mapZoomIndicatorActive$(){
    return computed(() => this.state().mapZoomIndicatorActive);
  }

  // public showHeader(position: number) {
  //   if (position < this.state().contentWrapperScrollPosition.top) {
  //     this.mutate((state) => {
  //       state.headerHidden = false;
  //     });
  //   }
  // }

  openMenu() {
    this.update((state) => ({ ...state, menuOpen: true, backgroundBlur: false }), 'Open Menu');
  }

  closeMenu() {
    this.mutate((state) => {
      if (state.menuOpen) {
        state.menuOpen = false;
        state.backgroundBlur = false;
      }
    }, 'Close Menu');
  }

  backgroundBlur() {
    this.update(state => ({...state,  backgroundBlur: true }), 'Activated Background Blur');
  }

  backgroundClear() {
    this.update(state => ({...state,  backgroundBlur: false }), 'Dectivated Background Blur');
  }

  showScroll() {
    this.update(state => ({...state,  preventScroll: false }), 'Show Scroll');
  }

  hideScroll() {
    this.update(state => ({...state,  preventScroll: true }), 'Hide Scroll');
  }

  updateNavigationTrigger(trigger) {
    this.update(state => ({...state,  navigationTrigger: trigger }), 'Update Navigation Trigger');
  }

  // updateScrollPosition(payload: any) {
  //   this.update(state => ({...state,  contentWrapperScrollPosition: payload }), 'Update Scroll Position');
  // }

  resetUI() {
    this.set(createInitalUI(), 'Reset Ui Store')
  }

  // restoreScrollPosition() {
  //   this.restoreScrollPosition$.next(null);
  // }

  hideMenu() {
    this.update(state => ({...state,  menuHidden: true }), 'Hide Menu');
  }

  showMenu() {
    this.update(state => ({...state,  menuHidden: false }), 'Show Menu');
  }

  hideHeader() {
    this.update(state => ({...state,  headerHidden: true }), 'Hide Header');
  }

  showHeader() {
    this.update(state => ({...state,  headerHidden: false }), 'Show Header');
  }

  collapseHeader() {
    this.update(state => ({...state,  headerCollapsed: true }), 'Collapse HEader');
  }

  unCollapseHeader() {
    this.update(state => ({...state,  headerCollapsed: false }), 'Uncollapse Header');
  }

  hideHeaderShadow() {
    this.update(state => ({...state,  hideHeaderShadow: true }), 'Hide Header Shadow');
  }

  showHeaderShadow(show) {
    this.update(state => ({...state,  hideHeaderShadow: show }), 'Show Header Shadow');
  }

  showHeaderBg(show) {
    this.update(state => ({...state,  showHeaderBg: show }), 'Show Header Background');
  }

  editAnnotations(active: boolean) {
    this.update(state => ({...state,  annotationsActive: active }), 'Edit Annotations');
  }

  mapZoomIndicatorActive(active: boolean) {
    this.update(state => ({...state,  mapZoomIndicatorActive: active }), 'Map Zoom Indicator toggle');
  }

  mapDrawError(error: boolean) {
    this.update(state => ({...state,  mapDrawingScaleError: error }), 'Map Drawing Scale Error');
  }

  setOnline(online: boolean) {
    this.update(state => ({...state,  online }), 'Online toggle');
  }

  shrinkHeader(shrink: boolean) {
    this.update(state => ({...state,  shrinkHeader: shrink }), 'Shrink header toggle');
  }

  showSearch(show: boolean = true) {
    this.update(state => ({...state,  showSearch: show }), 'Show Search');
  }

  updateHeaderContext(context: HeaderContext = null) {
    this.update(state => ({...state,  headerContext: context }), 'Set Header Context');
  }

  clearHeaderContext() {
    this.update(state => ({...state,  headerContext: null }), 'Clear Header Context');
  }

  spacedHeader(spaced: boolean = false) {
    this.update(state => ({...state,  spacedHeader: spaced }), 'Set Header Spaced');
  }

  allowThemeSwitching(allow: boolean = true) {
    this.update(state => ({...state,  allowThemeSwitching: allow }), 'Allow Theme Switcher toggle');
  }

  allowLanguageSwitching(allow: boolean = true) {
    this.update(state => ({...state,  allowLanguageSwitching: allow }), 'Allow Language Switcher toggle');
  }

  headerTransparent(transparent: boolean = false) {
    this.update(state => ({...state,  headerTransparent: transparent }), 'Header Transparent toggle');
  }

  updateActiveSection(section: string) {
    this.update(state => ({...state,  activeSection: section }), 'Set Active Section');
  }

  setLanguage(lang: string) {
    this.update(state => ({...state,  uiLanguage: lang }), 'Set Language');
  }

  hideFooter(hide: boolean) {
    this.update(state => ({...state,  hideMainFooter: hide }), 'Hide Footer toggle');
  }

  toggleFullscreen(active: boolean) {
    this.update(state => ({...state,  fullscreen: active }), 'Fullscreen Toggle');
  }

  setNativeScrolling(active: boolean) {
    this.update(state => ({...state,  nativeScrolling: active }), 'Native Scrolling toggle');
  }

  clearHeader(clear: boolean = false) {
    this.update(state => ({...state,  clearHeader: clear }), 'Clear Header');
  }
}
